

const UserManageReducer = (state = {}, action) => {
    switch (action.type) {
        case "getUserDataSuccess": {
            return Object.assign({}, state, {
                UsersList: action.data,
            });
            break;
        }
        case "UserDetails": {
            return Object.assign({}, state, {
                UserDetails: action.data,
            });
            break;
        }
        case "getshipListSuccess": {
            return Object.assign({}, state, {
                ShipNameList: action.data.ships,
            });
            break;
        }
        case "getUserDetailsSuccess": {
            return Object.assign({}, state, {
                UserInformation: action.data,
            });
            break;
        }
        default: {
            return state;
        }
    }
};
export default UserManageReducer;
